import { from } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { handleResponseError } from '@apis/http.interceptor';

import uuidUtils from '@utils/uuid.utils';
import baseConfig from '@config/base.config';
import cookieUtils from '@utils/cookie.utils';

import { useAccountInfo } from '@models/account/useAccountInfo';
import { useProfileInfo } from '@models/profile/useCurrentProfile';

const { account } = useAccountInfo();
const { profileInfo } = useProfileInfo();

// 预制缓存数据
const graphqlCache = new InMemoryCache({
    addTypename: false
});

const httpLink = new HttpLink({
    uri: `${import.meta.env.VITE_EXPERIENCE_SERVER_URL}/graphql`
});

const errorLink = onError(error => {
    handleResponseError(error.networkError?.statusCode, error.networkError?.result);
});

// 请求头添加token和space id
const authLink = setContext((_, context) => {
    const headers = { ...context.headers };
    const { ACCOUNT_TOKEN, LAST_PROFILE_ID } = baseConfig;
    const token = localStorage.getItem(ACCOUNT_TOKEN) || cookieUtils.getItem(ACCOUNT_TOKEN);
    const uid = account.value?.id;
    const sid = profileInfo.value?.sid || cookieUtils.getItem(LAST_PROFILE_ID);
    if (token) headers['authorization'] = `Bearer ${token}`;
    if (uid) headers['uid'] = uid;
    if (sid) headers['sid'] = sid;
    headers['traceId'] = uuidUtils.uuid();

    return { headers };
});

const apolloClient = new ApolloClient({
    link: from([authLink, errorLink, httpLink]),
    cache: graphqlCache,
    typeDefs: [],
    resolvers: {}
});

export default apolloClient;
